import { useEditor } from '@craftjs/core';
import { FORM_NODE_NAME } from '@/utils/constants';

/**
 * Hook to check if the current page has at least one Form element.
 * Reactively updates when nodes are added or removed from the craft.js tree.
 */
export const usePageHasForm = (): boolean => {
  const { hasForm } = useEditor((state) => {
    const nodes = state.nodes;
    const hasForm = Object.keys(nodes).some(
      (id) => nodes[id]?.data?.displayName === FORM_NODE_NAME,
    );
    return { hasForm };
  });

  return hasForm;
};
